import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconFilesSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M13 7.00793V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3.00003C3 2.44775 3.44772 2.00003 4 2.00003H7.99197C7.99718 1.99999 8.00239 1.99999 8.00759 2.00003H8.55556L13 6.00003V6.99257C13 6.99769 13 7.00281 13 7.00793ZM7 4.00003H5V12H11V8.00003H8C7.44772 8.00003 7 7.55231 7 7.00003V4.00003ZM9 6.00003V5.41424L9.58579 6.00003H9Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
